import { createSvgIcon } from "@mui/material/utils";

const FilterIcon = createSvgIcon(
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.666687 3.02904C0.666687 1.81641 1.64972 0.833374 2.86236 0.833374H15.1377C16.3503 0.833374 17.3334 1.81641 17.3334 3.02904C17.3334 5.05804 16.3535 6.96214 14.7024 8.14147L13.0955 9.28926C12.5342 9.69018 12.3437 9.83047 12.1944 9.98632C11.8595 10.336 11.6334 10.7754 11.5435 11.2512C11.5034 11.4632 11.5 11.6998 11.5 12.3896V16.6667C11.5 18.0474 10.3807 19.1667 9.00002 19.1667C7.61931 19.1667 6.50002 18.0474 6.50002 16.6667V12.3896C6.50002 11.6998 6.49661 11.4632 6.45654 11.2512C6.36663 10.7754 6.1405 10.336 5.80561 9.98632C5.65637 9.83047 5.46582 9.69018 4.90454 9.28926L3.29763 8.14147C1.64657 6.96214 0.666687 5.05804 0.666687 3.02904ZM2.86236 2.50004C2.5702 2.50004 2.33335 2.73688 2.33335 3.02904C2.33335 4.51979 3.05329 5.91877 4.26636 6.78525L5.87327 7.93304C5.89455 7.94824 5.91554 7.96322 5.93625 7.97801C6.41087 8.31685 6.73852 8.55078 7.00934 8.83357C7.56748 9.4164 7.94437 10.1488 8.09422 10.9417C8.16693 11.3264 8.16683 11.729 8.1667 12.3122C8.16669 12.3376 8.16669 12.3634 8.16669 12.3896V16.6667C8.16669 17.1269 8.53978 17.5 9.00002 17.5C9.46026 17.5 9.83335 17.1269 9.83335 16.6667V12.3896C9.83335 12.3634 9.83335 12.3376 9.83334 12.3122C9.83321 11.729 9.83311 11.3264 9.90582 10.9417C10.0557 10.1488 10.4326 9.4164 10.9907 8.83357C11.2615 8.55078 11.5892 8.31685 12.0638 7.97801C12.0845 7.96322 12.1055 7.94824 12.1268 7.93304L13.7337 6.78525C14.9467 5.91877 15.6667 4.51979 15.6667 3.02904C15.6667 2.73688 15.4298 2.50004 15.1377 2.50004H2.86236Z"
      fill="currentColor"
    />
  </svg>,
  "Filter"
);

export default FilterIcon;
